import { Flex } from '@npco/zeller-design-system'

import { useGetSites } from 'hooks/useGetSites'
import { useLoggedInUser } from 'hooks/useLoggedInUser'
import { CustomerRole } from 'types/gql-global-types'
import { GetSites_getSites_sites as SiteData } from 'types/gql-types/GetSites'
import { AddSiteButton } from 'pages/Settings/Sites/AddSiteButton/AddSiteButton'
import { SiteListItem } from 'pages/Settings/Sites/SiteListItem/SiteListItem'
import { StyledCopy } from 'pages/Settings/Sites/Sites.styled'
import { InfiniteList } from 'components/Lists/InfiniteList/InfiniteList'
import { SpinnerWrapped } from 'components/Spinner'
import { page } from 'translations'

import { NoSites } from '../NoSites/NoSites'

export const SitesList = () => {
  const { sites, isLoading, isLoadingMore, onLoadMore, hasMore } = useGetSites()
  const { userRole } = useLoggedInUser()

  if (!isLoadingMore && isLoading) {
    return <SpinnerWrapped variant="centre" />
  }

  if (sites.length === 0 && userRole === CustomerRole.MANAGER) {
    return (
      <Flex
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
      >
        <NoSites />
      </Flex>
    )
  }

  return (
    <InfiniteList<SiteData>
      data={sites}
      dataLength={sites.length}
      onScrollEnd={onLoadMore}
      hasMore={hasMore}
      renderItem={(site) => <SiteListItem key={site.id} site={site} />}
      header={
        <div>
          <StyledCopy>{page.settings.sites.copy}</StyledCopy>
          <AddSiteButton />
        </div>
      }
    />
  )
}
